/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import Doctor from "../../doctors.svg";

import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Provider } from "react-redux";

import { loginSuccess, addUser } from "../../redux/authRedux";
import Swal from "sweetalert2";
import { MouseEvent } from "react";
import { API_URL } from "../../network/api";

// const uri = 'http://localhost:9000/api/'

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const token = localStorage.getItem("token");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const handleClickShowEmail = () => setShowEmail((show) => !show);

  const handleMouseDownEmail = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const setlogin = () => {
    event.preventDefault();
    console.log(password, "password");
    const data = {
      email: email,
      password: password,
    };

    const api = axios.create({
      baseURL: API_URL,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    api
      .post("auth/login", data)
      .then(function (response) {
        Swal.fire({
          title: "Success",
          text: "successfully Login!",
          icon: "success",
          confirmButtonText: "OK",
          timer: 4000,
        }).then(function () {
          console.log(response.data.user.password, "password");
          dispatch(loginSuccess());
          dispatch(addUser(response.data));
          if (
            response.data.user.role === "Admin" ||
            response.data.user.role === "master"
          ) {
            navigate("/category");
          } else if (
            response.data.user.role === "stockController" &&
            response.data.isAdmin === true
          ) {
            navigate("/category");
          }
        });

        // console.log(response.data, 'data')
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.user.role);
        localStorage.setItem("shopID", response.data.user?.relatedShop?._id);
        const { appFeatures: { wallet } = {}, appType } =
          response?.data?.user?.relatedShop ?? {};
        console.log("wallet:", wallet, "appType:", appType);

        if (wallet && appType === "Aesthetic") {
          localStorage.setItem("walletFeature", true);
        } else {
          localStorage.removeItem("walletFeature");
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "Something Wrong Email or Password!",
          icon: "error",
          showConfirmButton: false,
          timer: 4000,
        });
      });
  };
  return (
    <div className="container-fluid">
      <div className="row" style={{ fontFamily: "serif" }}>
        <div className="col-8">
          <img src={Doctor} alt="" width="950px" height="600px" />
        </div>
        <div className="col-3 ">
          <div style={{ marginTop: "80px" }}>
            <div>
              <img
                src={require("../../assets/img/newLogo.png")}
                alt=""
                width="300px"
              />
            </div>

            <h1 className="fs-1" style={{ marginLeft: "20px" }}>
              Skin Symphony
            </h1>
            <span style={{ fontSize: "15px" }}>
              Hello, Greeting! Please Sign In to Your Account!
            </span>
            <form onSubmit={setlogin}>
              <div className="mt-3" style={{ marginLeft: "10px" }}>
                <FormControl sx={{ m: 1, width: "45ch" }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-email">
                    Email
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-email"
                    type={showEmail ? "text" : "email"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle email visibility"
                          onClick={handleClickShowEmail}
                          onMouseDown={handleMouseDownEmail}
                          edge="end"
                        >
                          {showEmail ? <EmailIcon /> : <EmailIcon />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FormControl>
              </div>
              <div className="mt-2" style={{ marginLeft: "10px" }}>
                <FormControl sx={{ m: 1, width: "45ch" }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </FormControl>
              </div>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  m: 1,
                  width: "37.5ch",
                  marginLeft: "17px",
                  marginTop: "20px",
                }}
                className="form-control"
              >
                Login
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
